import { WindowType } from './samweb-window.state';

export class CreateWindow {
   public static readonly type = '[Email] Create Window';

   constructor(public type: WindowType, public id: string) {}
}

export class RemoveWindow {
   public static readonly type = '[Email] Remove Window';

   constructor(public type: WindowType, public id: string) {}
}

export class ToggleWindow {
   public static readonly type = '[Email] Toggle Window';

   constructor(public type: WindowType, public id: string) {}
}

export class MaximizeWindow {
   public static readonly type = '[Window] Maximize Window';

   constructor(public type: WindowType, public id: string) {}
}

export class HideWindow {
   public static readonly type = '[Window] Hide Window';

   constructor(public type: WindowType, public id: string) {}
}

export class RestoreWindow {
   public static readonly type = '[Window] Restore Window';

   constructor(public type: WindowType, public id: string) {}
}

export class SetWindowIndex {
   public static readonly type = '[Window] Set Window Index';

   constructor(public type: WindowType, public id: string, public zIndex: number) {}
}

export class SetWindowTop {
   public static readonly type = '[Window] Set Window Top';

   constructor(public type: WindowType, public id: string, public top: number) {}
}

export class SetWindowLeft {
   public static readonly type = '[Window] Set Window Left';

   constructor(public type: WindowType, public id: string, public left: number) {}
}

export class SetWindowHeight {
   public static readonly type = '[Window] Set Window Height';

   constructor(public type: WindowType, public id: string, public height: number) {}
}

export class SetWindowWidth {
   public static readonly type = '[Window] Set Window Width';

   constructor(public type: WindowType, public id: string, public width: number) {}
}

export class SetWindowDraggedOrResized {
   public static readonly type = '[Window] Set Window Dragged Or Resized';

   constructor(public type: WindowType, public id: string, public isEdited: boolean) {}
}
